import { render } from "./MessagePage.vue?vue&type=template&id=6fe7e62d"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"

import "./MessagePage.vue?vue&type=style&index=0&id=6fe7e62d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__